import {ElementInputAutocomplete} from './element-input-autocomplete';

export class ElementInputGeoapifyAutocomplete extends ElementInputAutocomplete {
  public constructor() {
    super();

    this.typeElement = 'geoapifyAutocomplete';
  }
}
